import React from 'react';
import LocationTemplate from './LocationTemplate';

const WilmingtonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wilmington"
      stateName="North Carolina"
      countyName="New Hanover"
      zipCodes={["28401", "28402", "28403", "28404", "28405", "28406", "28407", "28408", "28409", "28410", "28411", "28412"]}
      latitude={34.2257}
      longitude={-77.9447}
      population={115451}
      historicalFact="Known as the 'Hollywood East' for its film industry; major port city founded in 1739."
      nearbyTowns={[
        "Wrightsville Beach, NC",
        "Carolina Beach, NC",
        "Leland, NC",
        "Burgaw, NC",
        "Castle Hayne, NC",
        "Kure Beach, NC",
        "Southport, NC",
        "Oak Island, NC"
      ]}
    />
  );
};

export default WilmingtonPage;